import {ITokenResponse} from "src/core/api/dto/TokenResponse.g";
import {actionCreator} from "../../core/store/common/actionCreator";

export class LoginAction {
    public static login = actionCreator.async<IEmpty, ITokenResponse, Error>("Auth/LOGIN");
    public static logOut = actionCreator.async<IEmpty, IEmpty, Error>("Auth/LOGOUT");
    // public static checkAuthorize = actionCreator.async<IEmpty, IEmpty, Error>("Auth/CHECK")
}
